/** Fixed ids and personas of the fictional demo data (no imports: safe for the web bundle). */

const id = (n: number) => `00000000-0000-4000-8000-${String(n).padStart(12, '0')}`;

export const DEMO = {
  admin: id(1),
  keller: id(2),
  wolf: id(3),
  brandt: id(4),
  aydin: id(5),
  hoffmann: id(6),
  richter: id(7),
  yilmaz: id(8),
  kaya: id(9),
  demir: id(10),
  berger: id(11),
  pInt: id(100),
  pKlinikum: id(101),
  pWeserpark: id(102),
  pLindenhof: id(103),
  pKranich: id(104),
};

export const DEMO_PERSONAS: { id: string; name: string; role: { de: string; en: string; tr: string } }[] = [
  { id: DEMO.keller, name: 'Dr. Jan Keller', role: { de: 'Geschäftsführer (Büro und Geschäftsführung)', en: 'Managing director (office and management)', tr: 'Genel müdür (ofis ve yönetim)' } },
  { id: DEMO.wolf, name: 'Sabine Wolf', role: { de: 'Assistenz (Büro und Geschäftsführung)', en: 'Assistant (office and management)', tr: 'Asistan (ofis ve yönetim)' } },
  { id: DEMO.brandt, name: 'Markus Brandt', role: { de: 'Projektleiter HLS (DE)', en: 'Project lead HVAC (DE)', tr: 'Proje lideri HLS (DE)' } },
  { id: DEMO.aydin, name: 'Elif Aydın', role: { de: 'Projektleiterin ELT (TR)', en: 'Project lead electrical (TR)', tr: 'Proje lideri ELT (TR)' } },
  { id: DEMO.hoffmann, name: 'Lena Hoffmann', role: { de: 'Ingenieurin HLS (DE)', en: 'Engineer HVAC (DE)', tr: 'Mühendis HLS (DE)' } },
  { id: DEMO.yilmaz, name: 'Emre Yılmaz', role: { de: 'BIM-Koordinator (TR)', en: 'BIM coordinator (TR)', tr: 'BIM koordinatörü (TR)' } },
  { id: DEMO.berger, name: 'Nina Berger', role: { de: 'Externe Fachplanerin', en: 'External consultant', tr: 'Harici uzman' } },
  { id: DEMO.admin, name: 'Admin', role: { de: 'Technischer Admin', en: 'Technical admin', tr: 'Teknik yönetici' } },
];
